<template>
  <div class='JZContainer accountStatement_detail_wrapper'>
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">对账单号：{{ JZFormInfo.prCode }}</span>
                <span :class="`status-${JZFormInfo.reconciliaState}`">
                {{ convertToName(reconciliaStateGroup, JZFormInfo.reconciliaState) }}
                </span>
              </div>
              <div class="customer">{{ JZFormInfo.unitName }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="退货信息">
            </a-tab-pane>
            <template v-if="$route.query.isWait!=='1'">
              <a-tab-pane key="2" tab="日志动态">
              </a-tab-pane>
              <a-tab-pane key="3" tab="开票信息">
              </a-tab-pane>
              <a-tab-pane key="4" tab="付款信息">
              </a-tab-pane>
              <a-tab-pane key="5" tab="核销信息">
              </a-tab-pane>
            </template>
          </a-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">账单基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="寄票联系人">{{JZFormInfo.ticketContactName || '--'}}</el-descriptions-item>
            <el-descriptions-item label="寄票电话">{{JZFormInfo.ticketPhone || '--'}}</el-descriptions-item>
            <el-descriptions-item label="寄票地址">{{JZFormInfo.provinceName || ''}}{{JZFormInfo.cityName || ''}}{{JZFormInfo.areaName || ''}}{{JZFormInfo.ticketAddress || '--'}}</el-descriptions-item>
            <el-descriptions-item label="对账区间">{{JZFormInfo.reconciliaStart || ''}} - {{JZFormInfo.reconciliaEnd || ''}}</el-descriptions-item>
            <el-descriptions-item label="对账单状态">{{
              {'wait': '待确认',
              'reject': '已驳回',
              'run': '结算中',
              'already': '已完成',
            }[JZFormInfo.reconciliaState] || '--'}}</el-descriptions-item>
            <el-descriptions-item label="对账总额"><span class="warning">{{JZFormInfo.reconciliaAmount && JZFormInfo.reconciliaAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}}</span>元</el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{JZFormInfo.unitName || '--'}}</el-descriptions-item>
            <el-descriptions-item v-if="status==='5'" label="核算单位">{{JZFormInfo.unitName || '--'}}</el-descriptions-item>
            <el-descriptions-item label="付款方式">{{ {
              'AC': '预付款',
              'AP': '账期付款',
            }[JZFormInfo.paymentWay] }}</el-descriptions-item>
            <el-descriptions-item label="账单创建人">{{JZFormInfo.createUserName || '--'}}</el-descriptions-item>
            <el-descriptions-item v-if="status==='2'" label="账单创建人部门">{{JZFormInfo.createDeptName || '--'}}</el-descriptions-item>
            <el-descriptions-item v-if="status==='4'" label="驳回原因">{{JZFormInfo.rejectReason || '--'}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div v-if="status!=='1'" class="common">
          <div class="title gap-12">账单执行信息</div>
          <el-form label-width="120px" label-position="right">
            <el-row :gutter="20">
              <el-col :span="6" class="borderRight">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="账单总金额：" >
                        {{JZFormInfo.reconciliaAmount && JZFormInfo.reconciliaAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}} 元
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="对账数量：" >
                        {{JZFormInfo.reconciliaNum}}
                      </el-form-item>
                    </el-col>
                  </el-row>
              </el-col>
              <el-col :span="12" class="borderRight">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开票金额：" >
                        {{JZFormInfo.invoicedAmount && JZFormInfo.invoicedAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}} 元
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="入票金额：" >
                        {{JZFormInfo.inTicketAmount && JZFormInfo.inTicketAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}} 元
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开票数量：" >
                        {{JZFormInfo.invoicedNum}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="入票数量：" >
                        {{JZFormInfo.inTicketNum}}
                      </el-form-item>
                    </el-col>
                  </el-row>
              </el-col>
              <el-col :span="6">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="已核销金额：" >
                        {{JZFormInfo.alreadyAmount && JZFormInfo.alreadyAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}} 元
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="待核销金额：" >
                        {{JZFormInfo.waitAmount && JZFormInfo.waitAmount.toLocaleString('en-US', { minimumFractionDigits: 2})}} 元
                      </el-form-item>
                    </el-col>
                  </el-row>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="common">
          <div class="title gap-12">对账明细
            <el-tooltip class="item" effect="dark" content="已经形成对账单的明细无法多次对账" placement="top-start">
              <i class="el-icon-info" style="margin-left:10px;" />
            </el-tooltip>
          </div>
          <TableWithPagination
            :leftToolbar="tableButtons"
            :columnList="columnList"
            :tableData="dataList"
            max-height='400px'
          />
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common">
          <OperationLog ref="operationLog"></OperationLog>
        </div>
      </template>
      <template v-if="activeKey === '3'">
        <div class="common">
          <BillingInformation ref="billingInformation"></BillingInformation>
        </div>
      </template>
      <template v-if="activeKey === '4'">
        <div class="common">
          <PaymentInformation ref="paymentInformation"></PaymentInformation>
        </div>
      </template>
      <template v-if="activeKey === '5'">
        <div class="common">
          <WriteOffInformation ref="writeOffInformation"></WriteOffInformation>
        </div>
      </template>
    </div>
    <BottomPanel v-if="$route.query.isWait==='1' && $withPermission('gongxutong:reconciliation_settlement:statement:audit')" class="adviceContainer">
      <el-form label-width="100px" label-position="right" class="adviceForm">
        <el-form-item label="审核意见：" >
          <el-input placeholder="请输入审核意见" v-model='reason' maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <el-button type="danger" plain @click="handleReject">驳回</el-button>
      <el-button type="primary" @click="handleSubmit">确认通过</el-button>
    </BottomPanel>
  </div>
</template>

<script>
import OperationLog from '@/components/operationLog/index.vue';
import BillingInformation from './components/billingInformation.vue';
import PaymentInformation from './components/paymentInformation.vue';
import WriteOffInformation from './components/writeOffInformation.vue';
import {exportTable, getDetailReconciliation, editReconciliationState} from '@/api/accountStatement';
import TableWithPagination, {
  TablePaginationMixin,
} from '@/components/common/TableWithPagination';

const reconciliaStateGroup = [
  { value: 'wait', label: '待确认' },
  { value: 'reject', label: '已驳回' },
  { value: 'run', label: '结算中' },
  { value: 'already', label: '已完成' },
];

export default {
  name: '',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
    OperationLog,
    BillingInformation,
    PaymentInformation,
    WriteOffInformation,
  },
  created () {
    this.initPage();
  },
  methods: {
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (v.value === value) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
      this.$nextTick(() => {
        if (this.activeKey === '2') {
          this.$refs.operationLog.getOperationLogLists();
        } else if (this.activeKey === '3') {
          this.$refs.billingInformation.initPage();
        } else if (this.activeKey === '4') {
          this.$refs.paymentInformation.initPage();
        } else if (this.activeKey === '5') {
          this.$refs.writeOffInformation.initPage();
        }
      });
    },
    initPage () {
      this.getDetailInfo();
      if (this.activeKey === '2' && this.status !== '1') {
        this.activeName = '1';
        this.$nextTick(() => {
          this.$refs.operationLog.getOperationLogLists();
        });
      }
    },
    getDetailInfo () {
      getDetailReconciliation({id: this.$route.query.id}).then(({body}) => {
        this.JZFormInfo = body;
        this.dataList = body.reconciliationList || [];
      });
    },
    exportTable () {
      let currentParams = {
        pageFlag: false,
        id: this.$route.query.id,
      };
      exportTable(currentParams).then(({data})=>{
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `对账明细_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      });
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleReject () {
      // 驳回接口
      if (!this.reason) {
        this.$JZShowAlert('驳回时驳回原因不可为空！', 'error');
        return;
      }
      editReconciliationState({id: this.$route.query.id, state: 'reject', supIdea: this.reason}).then(() => {
        this.goBack();
      });
    },
    handleSubmit () {
      editReconciliationState({id: this.$route.query.id, state: 'run', supIdea: this.reason}).then(() => {
        this.goBack();
      });
    },
    goBack () {
      this.$router.go(-1);
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      reconciliaStateGroup,
      reason: '',
      activeName: '1',
      JZFormInfo: {
      },
      dataList: [],
    };
  },
  computed: {
    tableButtons () {
      return [
        {
          name: '导出明细', // 按钮内容(必填)
          status: 'primary', // 按钮样式
          size: 'small', // 大小尺寸
          con: 'el-icon-printer', // 按钮内部icon
          code: 'exportTable', // code(必填)
          icon: '', // 按钮内部icon
          permission: '', // 权限码，若为空字符串或不设置则表示不进行权限控制
          click: this.exportTable, // 点击回调事件
        },
      ];
    },
    columnList () {
      let status = this.$route.query.status;
      let billTypecolumn = {
        tooltip: true,
        label: '单据类型',
        minWidth: '110px',
        prop: 'billType',
        render: (h, {row}) => {
          return h('div', row.billType === 'IN' ? '采购入库' : '采购退货出库');
        },
      };
      let indexColumn = {
        tooltip: true,
        label: '行号',
        minWidth: '70px',
        prop: 'Index',
        render: (h, {index}) => {
          let currentIndex = index + 1 + (this.pagination.currentPage - 1) * this.pagination.pageSize;
          return h('div', currentIndex);
        },
      };
      let salesmanName = [
        {
          tooltip: true,
          label: status === 'reject' ? '销售单号' : '采购单号',
          minWidth: '150px',
          prop: 'poCode',
        },
        {
          tooltip: true,
          label: 'sku编码',
          minWidth: '180px',
          prop: 'skuCode',
        },
        {
          tooltip: true,
          label: '收货信息',
          minWidth: '220px',
          prop: 'receivingName',
          render: (h, {row}) => {
            let msg = `${row.receivingName ? row.receivingName + '-' : ''}${
              row.receivingPhone ? row.receivingPhone + '-' : ''
            }${row.receivingProvinceName || ''}${row.receivingCityName || ''}${
              row.receivingAreaName || ''
            }${row.receivingAddrs || '--'}`;
            return h('span', msg);
          },
        },
        {
          tooltip: true,
          label: '关联仓库',
          minWidth: '110px',
          prop: 'warehouseName',
        },
        {
          tooltip: true,
          label: status === 'wait' ? '销售合同号' : '销售合同号',
          minWidth: '150px',
          prop: 'pcCode',
        },
        {
          tooltip: true,
          label: '业务员',
          minWidth: '150px',
          prop: 'salesmanName',
        },
        {
          tooltip: true,
          label: '业务员部门',
          minWidth: '150px',
          prop: 'salesmanDeptName',
        },
        {
          tooltip: true,
          label: '订单税率',
          minWidth: '150px',
          prop: 'taxRate',
          format: val => `${val}%`,
        },
        {
          tooltip: true,
          label: '付款方式',
          minWidth: '110px',
          prop: 'paymentWay',
          render: (h, {row}) => {
            let statusStr = {
              'AC': '预付款',
              'AP': '账期付款',
            }[row.paymentWay];
            return h('span', statusStr);
          },
        },
      ];
      let goodsColumn = [
        {
          tooltip: true,
          label: '商品名称',
          minWidth: '180px',
          prop: 'goodsName',
        },
        {
          tooltip: true,
          label: '规格',
          minWidth: 130,
          prop: 'specification',
        },
        {
          tooltip: true,
          label: '型号',
          minWidth: 130,
          prop: 'model',
        },
        {
          tooltip: true,
          label: '厂家编码',
          prop: 'factoryCode',
          minWidth: 130,
        },
      ];
      let unitOfMsmentColumn = {
        tooltip: true,
        label: '计量单位',
        minWidth: '150px',
        prop: 'unitOfMsment',
      };
      let stockDateColumn = {
        tooltip: true,
        label: '出入库日期',
        minWidth: '180px',
        prop: 'stockDate',
      };
      let stockNumColumn = {
        tooltip: true,
        label: '出入库数量',
        minWidth: '110px',
        prop: 'stockNum',
      };
      let stockCodeColumn = {
        tooltip: true,
        label: '出入库单号',
        minWidth: '130px',
        prop: 'stockCode',
      };
      let stockAmountColumn = {
        tooltip: true,
        label: '出入库金额',
        minWidth: '110px',
        prop: 'stockAmount',
        format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
      };
      let invoicedNumColumn = {
        tooltip: true,
        label: '开票数量',
        minWidth: '110px',
        prop: 'invoicedNum',
      };
      let waitInvoicedNumColumn = {
        tooltip: true,
        label: '待开票数量',
        minWidth: '110px',
        prop: 'waitInvoicedNum',
      };
      let writeOffNumColumn = {
        tooltip: true,
        label: '开票冲销数量',
        minWidth: '110px',
        prop: 'writeOffNum',
      };
      let inTicketNumColumn = {
        tooltip: true,
        label: '入票数量',
        minWidth: '110px',
        prop: 'inTicketNum',
      };
      let inTicketAmountColumn = {
        tooltip: true,
        label: '入票金额',
        minWidth: '110px',
        prop: 'inTicketAmount',
        format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
      };
      let currentLists = [];
      if (this.$route.query.isWait) {
        currentLists = [
          indexColumn,
          billTypecolumn,
          ...goodsColumn,
          unitOfMsmentColumn,
          stockDateColumn,
          stockNumColumn,
          waitInvoicedNumColumn,
          writeOffNumColumn,
          {
            tooltip: true,
            label: '订单单价',
            minWidth: '110px',
            prop: 'orderPrice',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          stockAmountColumn,
          {
            tooltip: true,
            label: '订单税率',
            minWidth: '110px',
            prop: 'taxRate',
            format: val => `${val}%`,
          },
          stockCodeColumn,
          {
            tooltip: true,
            label: '采购单号',
            minWidth: '150px',
            prop: 'poCode',
          },
          {
            tooltip: true,
            label: 'sku编码',
            minWidth: '180px',
            prop: 'skuCode',
          },
          {
            tooltip: true,
            label: '关联仓库',
            minWidth: '150px',
            prop: 'warehouseName',
          },
          {
            tooltip: true,
            label: '销售合同号',
            minWidth: '150px',
            prop: 'pcCode',
          },
        ];
      } else if (status === 'run') {
        currentLists = [
          indexColumn,
          stockDateColumn,
          ...goodsColumn,
          {
            tooltip: true,
            label: '销售单价',
            minWidth: '110px',
            prop: 'orderPrice',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          unitOfMsmentColumn,
          stockNumColumn,
          invoicedNumColumn,
          waitInvoicedNumColumn,
          inTicketNumColumn,
          {
            tooltip: true,
            label: '开票金额',
            minWidth: '110px',
            prop: 'invoicedAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          inTicketAmountColumn,
          stockAmountColumn,
          {
            tooltip: true,
            label: '核销数量',
            minWidth: '110px',
            prop: 'invoicedNum',
          },
          stockAmountColumn,
          {
            tooltip: true,
            label: '核销金额',
            minWidth: '110px',
            prop: 'alreadyAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          {
            tooltip: true,
            label: '未核销金额',
            minWidth: '110px',
            prop: 'waitAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          billTypecolumn,
          stockCodeColumn,
          ...salesmanName,
          {
            tooltip: true,
            label: '已冲销开票数量',
            minWidth: '150px',
            prop: 'writeOffNum',
          },
        ];
      } else if (status === 'already') {
        currentLists = [
          indexColumn,
          stockDateColumn,
          billTypecolumn,
          ...goodsColumn,
          {
            tooltip: true,
            label: '销售单价',
            minWidth: '110px',
            prop: 'orderPrice',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          unitOfMsmentColumn,
          stockNumColumn,
          inTicketNumColumn,
          inTicketAmountColumn,
          {
            tooltip: true,
            label: '核销数量',
            minWidth: '110px',
            prop: 'invoicedNum',
          },
          {
            tooltip: true,
            label: '商品金额',
            minWidth: '110px',
            prop: 'goodsAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          stockAmountColumn,
          stockCodeColumn,
          ...salesmanName,
          {
            tooltip: true,
            label: '客户抬头',
            minWidth: '180px',
            prop: 'unitName',
            format: () => this.JZFormInfo.unitName || '--',
          },
          {
            tooltip: true,
            label: '已冲销开票数量',
            minWidth: '150px',
            prop: 'writeOffNum',
          },
        ];
      } else if (status === 'reject') {
        currentLists = [
          indexColumn,
          stockDateColumn,
          billTypecolumn,
          ...goodsColumn,
          {
            tooltip: true,
            label: '销售单价',
            minWidth: '110px',
            prop: 'orderPrice',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          unitOfMsmentColumn,
          stockNumColumn,
          invoicedNumColumn,
          {
            tooltip: true,
            label: '冲销开票数量',
            minWidth: '110px',
            prop: 'writeOffNum',
          },
          waitInvoicedNumColumn,
          inTicketNumColumn,
          inTicketAmountColumn,
          {
            tooltip: true,
            label: '商品金额',
            minWidth: '110px',
            prop: 'goodsAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          stockCodeColumn,
          ...salesmanName,
        ];
      } else if (status === 'wait') {
        currentLists = [
          indexColumn,
          stockDateColumn,
          billTypecolumn,
          ...goodsColumn,
          {
            tooltip: true,
            label: '销售单价',
            minWidth: '110px',
            prop: 'orderPrice',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          unitOfMsmentColumn,
          stockNumColumn,
          invoicedNumColumn,
          {
            tooltip: true,
            label: '冲销开票数量',
            minWidth: '110px',
            prop: 'writeOffNum',
          },
          waitInvoicedNumColumn,
          inTicketNumColumn,
          inTicketAmountColumn,
          {
            tooltip: true,
            label: '商品金额',
            minWidth: '110px',
            prop: 'goodsAmount',
            format: val => `${val === null || val === '' ? '--' : val.toLocaleString('en-US', { minimumFractionDigits: 2})}`,
          },
          stockCodeColumn,
          ...salesmanName,
        ];
      }
      return currentLists;
    },
    status () {
      let status = ['', 'wait', 'run', 'already', 'reject'].indexOf(this.$route.query.status) + '';
      return status;
    },
  },
};
</script>
<style scoped lang='scss'>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.accountStatement_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              .status-run {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-already {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }

              .status-wait {
                @include tag_round();
                background-color: #FEFEE5;
                color: #FAB007;
              }

              .status-reject {
                @include tag_round();
                background-color: #FEE9E5;
                color: #FF5959;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }

  /deep/ .borderRight{
    border-right: 1px solid #999999;
  }
  /deep/ .adviceContainer{
    display: flex;
    .adviceForm{
      flex: 1;
      margin-right: 20px;
      .el-form-item{
        margin-bottom: 0;
      }
    }
  }
  /deep/ .warning {
    color: #EC808D;
    font-size: 16px;
    margin-right: 5px;
  }
  /deep/.el-form-item--mini.el-form-item, /deep/ .el-form-item--small.el-form-item{
    margin-bottom: 1px;
  }
  /deep/ .el-form-item__label,/deep/ .el-form-item__content {
    font-size: 12px;
  }

  /deep/ .el-form-item--small .el-form-item__content,/deep/ .el-form-item--small .el-form-item__label {
    line-height: 26px;
  }
}
</style>
